import type { MemberDto } from '@reelplicate/api-client/model';

/** A member's display name: their name, else their email. */
export const memberName = (member: MemberDto) =>
  member.name ?? member.email ?? 'Unknown member';
